import React from "react";
import T from "prop-types";
import Warning from "MODULES/shared/components/Warning/Warning";

const LastExchangeWarning = ({ isLastExchange }) => {
  if (isLastExchange) return null;

  return (
    <Warning>
      Invoice Paid Date must be entered on the most recent exchange transaction
      for this item. (i.e. 2nd exch or 3rd exch).
    </Warning>
  );
};

LastExchangeWarning.propTypes = {
  isLastExchange: T.bool.isRequired
};

export default LastExchangeWarning;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Billing/LastExchangeWarning.jsx